module.exports = __webpack_public_path__ + "static/media/icon_app_store_zh.9b98cb6e.png";